import { PlatformInfo } from './types';
import { PlatformPatterns } from './platform-patterns';
import { SellerDetector } from './seller-detector';
import { TransactionTypeDetector } from './transaction-type-detector';
import { PlatformData } from './platform-data';

export type { PlatformInfo } from './types';

export class PlatformDetector {
  static detectPlatform(merchantName: string, orderNumber?: string, issue?: string): PlatformInfo {
    const searchText = `${merchantName} ${orderNumber || ''} ${issue || ''}`.toLowerCase();
    
    // Detect platform
    const platform = PlatformPatterns.detectPlatformFromText(searchText) as PlatformInfo['platform'];

    // Detect if private seller
    const isPrivateSeller = SellerDetector.isPrivateSeller(merchantName, searchText, platform);
    
    // Determine transaction type
    const transactionType = TransactionTypeDetector.determineTransactionType(platform, isPrivateSeller, merchantName);
    
    // Get platform-specific data
    const platformSpecificData = PlatformData.getPlatformSpecificData(platform, isPrivateSeller);

    return {
      platform,
      isPrivateSeller,
      transactionType,
      platformSpecificData
    };
  }
}
